module.exports = __webpack_public_path__ + "assets/79.jpg?de006e125b0dec29fbd8fbfcf5fc1b06";